import { TabAnimationSettingsModel } from '@syncfusion/ej2-angular-navigations';

export const noAnimation: TabAnimationSettingsModel = {
  previous: { effect: 'None' },
  next: { effect: 'None' },
};

export type TabIndex = Record<string, number>;
